let baseUrl = 'https://api.depositbd.my.id/api';

if (process.env.NODE_ENV === 'production') {
  baseUrl = 'https://api.depositbd.my.id/api';
} else {
  baseUrl = 'https://api.depositbd.my.id/api';
}

export const config = {
  baseUrl,
};
